import React, { createContext, useContext } from "react";
import { toast } from "./Toast";

interface ToastContextProps {
  showToast: (
    message: string,
    type: "success" | "error" | "warning" | "info"
  ) => void;
  clearAllToasts: () => void;
}

const ToastContext = createContext<ToastContextProps | undefined>(undefined);

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const showToast = (
    message: string,
    type: "success" | "error" | "warning" | "info"
  ) => {
    switch (type) {
      case "success":
        toast.success(message);
        break;
      case "error":
        toast.fail(message);
        break;
      case "warning":
        toast.warning(message);
        break;
      case "info":
        toast.info(message);
        break;
    }
  };

  const clearAllToasts = () => {
    toast.clearAll();
  };

  const contextValue: ToastContextProps = {
    showToast,
    clearAllToasts,
  };

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
    </ToastContext.Provider>
  );
};

export default ToastProvider;
